<template>
    <div>
            <v-autocomplete
                prepend-inner-icon="search"
                v-model="selectedTargetSid"
                :items="items"
                solo-inverted
                flat
                hide-details
                :label="searchLabel"
                @change="getTargetProfile()"
              ></v-autocomplete>
    </div>
</template>

<script>
export default {
    name: 'VueElearningSelectTarget',
    props: {
        items: {
            default:[]
        }
    },
    data() {
        return {
            searchLabel: "Search Student",
            selectedTargetSid:null
        };
    },

    mounted() {
        
    },

    methods: {
        getTargetProfile() {
            this.$emit('target-selected',this.selectedTargetSid)
        }
    },
};
</script>

<style lang="scss" scoped>

</style>